<app-modal
  [title]="(isAdd ? 'Add customer' : 'Edit customer') | trans:namespace + '/header/title'"
  maxWidth="525px"
>
  <ng-template>
    <div>
      <app-add-edit-customer-form [isAdd]="isAdd" [data]="data" #formComponent />
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-32">
      <button
        class="button button--md button--secondary text-uppercase flex-grow-1 w-0"
        (click)="close()"
        [disabled]="isFormSubmitting"
      >
        {{ 'Cancel' | trans:namespace + '/buttons/cancel' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase flex-grow-1 w-0"
        (click)="submitForm()"
        [disabled]="isFormSubmitting"
      >
        {{ 'Confirm' | trans:namespace + '/buttons/confirm' }}
      </button>
    </div>
  </ng-container>
</app-modal>
